import { Navigate, useLocation, useParams } from 'react-router-dom'

/** What a redirect target is built from. */
export interface RedirectContext {
  /** The route's `:slug` param ('' when the route has none). */
  slug: string
  pathname: string
  /** The current query string, '' or starting with '?'. */
  search: string
}

interface Props {
  /** Builds the destination path from the current location. */
  to: (ctx: RedirectContext) => string
  /** Append the current query string verbatim to the built path. */
  preserveQuery?: boolean
}

/** A legacy URL → its new home, as a history REPLACE (the old URL never
 *  lands in the back stack). The single redirect component behind every
 *  retired route in App.tsx. */
export function Redirect({ to, preserveQuery = false }: Props) {
  const { slug = '' } = useParams<{ slug: string }>()
  const { pathname, search } = useLocation()
  const target = to({ slug, pathname, search })
  return <Navigate to={preserveQuery ? `${target}${search}` : target} replace />
}
